enum BenefitImageTypes {
  banner = 1,
}

export default BenefitImageTypes;
